<template>
  <div class="tours">
    <div class="top">
      <div class="title">新闻中心</div>
    </div>
    <div class="news-title">{{ detail.news_title }}</div>
    <div class="news-time">
      <span>{{ detail.create_time }}</span>
      <span v-if="detail.writer">作者：{{ detail.writer }}</span>
    </div>
    <div class="content">
      <div class="news-p" v-html="detail.news_content"></div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      detail: {}
    }
  },
  mounted() {
    console.log(this.$route.query.news_id)
    this.getDetailFn()
  },
  methods: {
    getDetailFn() {
      this.loading = true
      this.$http.news_list_view({
        type_id: 755,
        news_id: this.$route.query.news_id,
      }).then(res => {
        console.log(res)
        this.detail = res.data[0]
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.tours {
  padding-bottom: 180px;
  background-color: #f1f1f1;

  .big-img {
    width: 80%;
    max-width: 1000px;
    margin: 40px auto;
    display: block;
  }


  .top {
    width: 100vw;
    height: 340px;
    position: relative;
    overflow: hidden;
    background-image: url('../../assets/imgs/study_in_australia.jpg');
    background-size: auto 100%;
    transition: .3s all;
    background-position: center;

    .title {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 60px;
      font-weight: 600;
      letter-spacing: 2px;
      color: #ae0000;
      text-shadow: 3px 3px 5px #fff;
    }



    img {
      width: 100%;
      object-fit: cover;
      height: 100%;
      transition: .3s all;
    }

    &:hover {
      background-size: auto 110%;

      img {
        transform: scale(1.1);
      }
    }
  }

  .news-title {
    font-size: 30px;
    font-weight: 600;
    text-align: center;
    margin: 80px 0 20px;
  }

  .news-time {
    font-size: 12px;
    text-align: center;
    margin: 20px 0;
    color: #666;

    span {
      margin: 0 10px;
    }
  }

  .news-text {
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    margin: 20px 0;
  }

  .content {
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    max-width: 1200px;
    margin: 20px auto;
  }

  .news-p {
    font-size: 20px;
    font-weight: 600;
    text-align: center;
  }

}


@media (max-width: 600px) {
  .tours {
    padding-bottom: 30px;

    .top {
      height: 200px;

      .title {
        font-size: 30px;
      }
    }

    .nav {
      padding: 10px 0;
      border-width: 10px;

      .nav-con {
        font-size: 16px;
      }
    }

    .lists {
      .list {
        width: calc(50% - 20px);
        margin: 20px 10px 0;

        .img {
          height: 200px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/zh/newsDetail.vue